<template>
  <q-toolbar>
    <SanCurrentRefinements
      class="san-filters-cloud"
      list-class="san-filters-cloud--group"
    >
      <template #default="{ items }">
        <SanFilterCloudGroup
          v-for="(item, i) in items"
          :key="i"
          :label="t(`Filter.${item.label.split('.')[0]}.label`)"
          :items="item.refinements"
          :refine="item.refine"
        />

        <SanClearRefinements>
          <template #default="{ canRefine, refine }">
            <SanButton
              v-if="canRefine"
              size="sm"
              :label="t('Tools.clearAll.label')"
              icon="mono-delete"
              color="negative-mid"
              flat
              :disabled="!canRefine"
              @click.prevent="refine"
            >
              <Tooltip type="negative">
                {{ t('Tools.clearAll.tooltip') }}
              </Tooltip>
            </SanButton>
          </template>
        </SanClearRefinements>
      </template>
    </SanCurrentRefinements>
  </q-toolbar>
</template>

<script setup>
import { useTranslation } from 'i18next-vue'
import SanFilterCloudGroup from '@/components/filters/SanFilterCloudGroup.vue'

defineOptions({ name: 'SanFilterCloud' })

const { t } = useTranslation('filters')
</script>
